import React, { useImperativeHandle, forwardRef, useRef, useState, useEffect, useContext, useMemo } from 'react';
import { Button, Empty, Tabs, message, Input } from 'antd';
import styles from './index.module.scss'
import API from '@api/api'
import { AppContext } from '@utils/AppContext';
import { HOME_PAGE_TYPE, IMAGE_TYPE } from '@utils/CONST';
import dayjs from 'dayjs';
import InfiniteScroll from 'react-awesome-infinite-scroll';
import Utils from '@utils/utils';
import GoBack from '../goBack/goBack';
import Iconfont from '@utils/Iconfont';
import { CheckSquareFilled } from '@ant-design/icons';

const list = [{
    title: '服饰版',
    key: 'model',
    img_nomal: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon1_nomal.png',
    img_active: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon1_active.png',
}, {
    title: '商品版',
    key: 'commodity',
    img_nomal: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon2_nomal.png',
    img_active: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon2_active.png',
}, {
    title: 'AI编辑',
    key: 'aiEdit',
    img_nomal: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon3_nomal.png',
    img_active: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon3_active.png',
}, {
    title: '企业版',
    key: 'bachImage',
    img_nomal: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/batchImahe_nomal.png',
    img_active: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/batchImahe_active.png',
}]

const ProjectItem = (props) => {
    return (
        <div className={styles.ProjectItem}>
            <div className={`${styles.ProjectItemCover} ${props.favorite && styles.favoriteBox}`}>
                {
                    props.favorite ?
                        props.mainImage ?
                            <img src={props.tabKey === 'bachImage' ?
                                Utils.getImgThumbnail(props.skuImageList?.[0]) :
                                Utils.getImgThumbnail(props.mainImage?.split(',')[0])} /> :

                            <div className={styles.empty_img}></div> :
                        <img src={props.tabKey === 'bachImage' ?
                            Utils.getImgThumbnail(props.skuImageList?.[0]) :
                            Utils.getImgThumbnail(props.mainImage?.split(',')[0])} />
                }
                {
                    props.mainImage || props.skuImageList?.length > 0 ?
                        <div className={styles.mask} onClick={props.onClick}>
                            <div className={styles.check_view}>查看合集</div>
                        </div> : ""
                }
            </div>
            {
                props.favorite ?
                    <>
                        <p className={styles.ProjectName}>
                            <i className={styles.favor_icon}></i>
                            <span>{props.projectName}</span>
                        </p>
                        <p className={styles.UpdatedTime}></p>
                    </> :
                    <>
                        <p className={styles.ProjectName}>{props.projectName}</p>
                        <p className={styles.UpdatedTime}>修改时间 {dayjs(props.updatedTime).format('YYYY/MM/DD HH:mm')}</p>
                    </>
            }
        </div>
    )
}

const TaskItem = (props) => {
    return (
        <div
            className={`${styles.TaskItem} ${props.selectTaskId && props.selectTaskId.some(item => item.taskId === props.taskId) ? styles.actived : ''}`}
            onClick={props.onClick}
        >
            <img src={Utils.getImgThumbnail(props.results[0].image)} />
            {
                props.selectTaskId && props.selectTaskId.some(item => item.taskId === props.taskId) &&
                <CheckSquareFilled className={styles.selectIcon} />
            }
        </div>
    )
}

// 已选图列表
const SelectedList = forwardRef((props, ref) => {
    const { selected, setSelected, setShowSelected } = props

    useImperativeHandle(ref, () => ({
        onSubmit
    }))

    const onSubmit = () => {
        props.onSubmitWrapper()
    }

    const cancleSelect = (item) => {
        setSelected(prevSelected => prevSelected.filter(selectedItem => selectedItem.taskId !== item.taskId))
    }

    return (
        <>
            <div style={{ display: 'flex' }}>
                <GoBack goBack={() => setShowSelected(false)} />
                <p className={styles.Title} style={{ marginLeft: '20px' }}><span>已选图片</span></p>
            </div>
            <div className={styles.SelectedList}>
                {
                    selected.map(item => (
                        <div
                            className={`${styles.TaskItem} ${styles.TaskItem2}`}
                            onClick={props.onClick}
                        >
                            <p className={styles.DeleteIcon} onClick={() => cancleSelect(item)}><Iconfont type="icon-DeleteOutlined" /></p>
                            <img src={Utils.getImgThumbnail(item.results[0].image)} />
                        </div>
                    ))
                }
            </div>
        </>
    )
})

const TaskList = forwardRef((props, ref) => {
    const [taskList, setTaskList] = useState([])
    const { globalUser } = useContext(AppContext)

    useImperativeHandle(ref, () => ({
        onSubmit
    }))

    const onSubmit = () => {
        props.onSubmitWrapper()
    }


    useEffect(() => {
        if (props.tabKey === 'bachImage') {
            API.batchListResult({ projectId: props.projectId }).then(res => {
                if (res.code != 0) throw new Error(res.message)
                const taskList = res.data.filter(item => item.status == "succeeded")
                setTaskList(taskList)
            })
        } else {
            if (props.projectId == 'favorite') {
                API.listBookmarkTaskv2({
                    module: props.tabKey, // model or commodity
                    member: props.member == 'team' ? null : props.member ? props.member : globalUser?.id
                }).then(res => {
                    if (res.code != 0) throw new Error(res.message)
                    console.log('setFavoriteList', res.data.filter(item => item.results.length > 0))
                    setTaskList(res.data.filter(item => item.results.length > 0))
                })
            } else {
                API.getProjectDetailv2({
                    projectId: props.projectId,
                    member: props.member == 'team' ? null : props.member ? props.member : globalUser?.id
                }).then(res => {
                    console.log(res)
                    if (res.code != 0) throw new Error(res.message)
                    const taskList = res.data.taskList.filter(item => item.status == "succeeded" && item.results.length > 0)
                    setTaskList(taskList.reverse())
                })
            }
        }

    }, [props.projectId])

    const onPickTask = (item) => {
        props.setSelected(prevSelected => {
            if (prevSelected.some(selectedItem => selectedItem.taskId === item.taskId)) {
                return prevSelected.filter(selectedItem => selectedItem.taskId !== item.taskId)
            } else {
                return [...prevSelected, item]
            }
        })
    }

    return (
        <div className={`${styles.ListContent2} _beauty_scrollbar`}>
            {
                taskList.map(item => (
                    <TaskItem
                        selectTaskId={props.selected}
                        key={item.taskId}
                        {...item}
                        onClick={() => onPickTask(item)}
                    />
                ))
            }
        </div>
    )
})


const PickFromProject = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        onSubmit: onSubmitWrapper
    }));

    const onSubmitWrapper = () => {
        try {
            if (!selected.length) return false
            return selected
        } catch (err) {
            message.warning(err.message)
        }
    }

    const [tabKey, setTabKey] = useState('model')
    const taskListRef = useRef()
    const [projectId, setProjectId] = useState()
    const [projectName, setProjectName] = useState()
    const [searchProjectName, setSearchProjectName] = useState(null)
    const [projectList, setProjectList] = useState([])
    const [selected, setSelected] = useState([])
    const pageIndexRef = useRef(1)
    const pageSizeRef = useRef(18)
    const [total, setTotal] = useState(0)
    const [hasMore, setHasMore] = useState()
    const [showSelected, setShowSelected] = useState(false)
    const { globalUser, globalOrgInfo } = useContext(AppContext)
    const [member, setMember] = useState(globalUser?.id)
    const [tabKeyProType, setTabKeyProType] = useState('1')


    const fetchMoreData = async () => {
        pageIndexRef.current = pageIndexRef.current + 1
        API.listProjectv2({
            module: tabKey,
            pageIndex: pageIndexRef.current,
            pageSize: pageSizeRef.current,
            member: member == 'team' ? null : member ? member : globalUser?.id,
            projectName: searchProjectName || null
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            const next = projectList?.concat(res.data.items)
            setProjectList(next.filter(item => item.imageType != IMAGE_TYPE.MODEL_VIDEO))
            setTotal(res.data.total)
            setHasMore(next.length < res.data.total)
        }).catch(err => {
            message.warning(err.message)
        })
    }

    useEffect(() => {
        pageIndexRef.current = 1
        if (tabKey == 'bachImage') {
            API.listBatchProject({
                pageIndex: 1,
                pageSize: 10000,
                myProjectData: true,
                member: member == 'team' ? null : member ? member : globalUser?.id,
                projectName: searchProjectName || null
            }).then(res => {
                if (res.code === 0) {
                    setProjectList(res.data.items)
                    setTotal(res.data.total)
                    setHasMore(res.data.items.length < res.data.total)
                }
            })
        } else {
            API.listProjectv2({
                module: tabKey,
                pageIndex: pageIndexRef.current,
                pageSize: pageSizeRef.current,
                member: member == 'team' ? null : member ? member : globalUser?.id,
                projectName: searchProjectName || null
            }).then(res => {
                if (res.code != 0) throw new Error(res.message)
                setProjectList(res.data.items.filter(item => item.imageType != IMAGE_TYPE.MODEL_VIDEO))
                setTotal(res.data.total)
                setHasMore(res.data.items.length < res.data.total)
            }).catch(err => {
                message.warning(err.message)
            })
        }
    }, [tabKey, member, searchProjectName])

    const onPickProject = (project) => {
        setProjectId(project.id)
        setProjectName(project.projectName)
    }

    const onCancelProject = () => {
        setProjectId()
        setProjectName()
        setMember(globalUser?.id)
    }

    const [favoriteList, setFavoriteList] = useState([])
    useEffect(() => {
        if (tabKey == 'bachImage') return
        API.listBookmarkTaskv2({
            module: tabKey,
            member: member == 'team' ? null : member ? member : globalUser?.id
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            setFavoriteList(res.data.filter(item => item.results.length > 0))
        })
    }, [tabKey, member])

    const firstFavorite = useMemo(() => {
        return favoriteList[0]
    }, [favoriteList])

    return (
        <div className={styles.ListContainer}>
            <div className={styles.ListContainerLeft}>
                {
                    list.map((item) => (
                        <div
                            className={styles.ProjectSidebarItem}
                            key={item.key}
                            onClick={() => { setProjectId(); setProjectName(''); setShowSelected(false); setTabKey(item.key); setMember(globalUser?.id) }}
                        >
                            <img src={Utils.getImgThumbnail(tabKey == item.key ? item.img_active : item.img_nomal)} alt="" />
                            <p style={{ color: tabKey == item.key ? '#006EFF' : '#5B6673' }} >{item.title}</p>
                        </div>
                    ))
                }
            </div>
            <div className={styles.ListContainerRight}>
                {
                    showSelected ? <SelectedList
                        selected={selected}
                        setShowSelected={setShowSelected}
                        setSelected={setSelected}
                    /> : <>
                        {
                            projectName ?
                                <div style={{ display: 'flex' }}><GoBack goBack={onCancelProject} />
                                    <p className={styles.Title} style={{ marginLeft: '20px' }}><span>{projectName}</span></p>
                                </div> :
                                tabKey != 'bachImage' ?
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            (globalOrgInfo?.current?.role == 'admin') ? <Tabs items={[
                                                { key: '1', label: '个人项目' }, { key: '2', label: '企业项目' }
                                            ]} onChange={(val) => {
                                                setTabKeyProType(val)
                                                if (val == '1') {
                                                    setMember(globalUser?.id)
                                                } else setMember('team')
                                            }} style={{ width: '100%' }} /> : <div style={{ width: '100%' }}></div>
                                        }
                                        <Input
                                            allowClear
                                            style={{ width: '400px' }}
                                            value={searchProjectName}
                                            className={styles.focused}
                                            placeholder="请搜索项目名称"
                                            suffix={<Iconfont type="icon-SearchOutlined" style={{ fontSize: 16, color: '#5b6673' }} />}
                                            onChange={(e) => setSearchProjectName(e.target.value)}
                                        />
                                    </div> :
                                    <p style={{ height: '46px', textAlign: 'right' }}>
                                        <Input
                                            allowClear
                                            style={{ width: '288px' }}
                                            value={searchProjectName}
                                            className={styles.focused}
                                            placeholder="请搜索项目名称"
                                            suffix={<Iconfont type="icon-SearchOutlined" style={{ fontSize: 16, color: '#5b6673' }} />}
                                            onChange={(e) => setSearchProjectName(e.target.value)}
                                        />
                                    </p>
                        }
                        <div className={`${styles.ListContent} ${projectId && styles.Hidden} _beauty_scrollbar`}>
                            <InfiniteScroll
                                length={projectList?.length}
                                next={fetchMoreData}
                                hasMore={hasMore}
                                scrollableParent={document.querySelector(styles.ListContent)}
                                pullDownComponent={<div style={{ height: "50px", background: "green" }}>下拉</div>}
                                releaseComponent={<div style={{ height: "50px", background: "red" }}>释放</div>}
                                refreshingComponent={<div style={{ height: "50px", background: "green" }}>加载中</div>}
                                refreshEndComponent={<div style={{ height: "50px", background: "red" }}>加载完成</div>}
                                loadingComponent={<div style={{ height: "50px", lineHeight: "50px", textAlign: 'center' }}><h4>加载中...</h4></div>}
                                endComponent={
                                    (projectList?.length) ?
                                        <div style={{ height: "30px", lineHeight: "30px", textAlign: 'center', fontWeight: 'normal', color: '#999' }}>
                                            <span>没有更多内容了</span>
                                        </div> : <div className={styles.EmptyContent}><Empty /></div>
                                }
                            >
                                {
                                    (projectList?.length && tabKey != 'bachImage') ?
                                        <ProjectItem
                                            key={"favorite"}
                                            favorite={true}
                                            mainImage={firstFavorite ? firstFavorite.results?.[0]?.image?.split(',')[0] : ""}
                                            projectName={member == 'team' ? '企业收藏' : '我的收藏'}
                                            onClick={() => onPickProject({ id: 'favorite', projectName: member == 'team' ? '企业收藏' : '我的收藏' })}
                                        /> : <></>
                                }
                                {
                                    projectList.map(item => (
                                        <ProjectItem
                                            tabKey={tabKey}
                                            key={item.id}
                                            {...item}
                                            onClick={() => onPickProject(item)}
                                        />
                                    ))
                                }
                            </InfiniteScroll>
                        </div>
                        {
                            !projectId ? "" :
                                <TaskList
                                    ref={taskListRef}
                                    tabKey={tabKey}
                                    member={member}
                                    projectId={projectId}
                                    showAllType={props.showAllType}
                                    selected={selected}
                                    setSelected={setSelected}
                                    onSubmitWrapper={onSubmitWrapper}
                                />
                        }
                    </>
                }
            </div>

            {
                !showSelected && <p className={`${styles.SelectedBtn} ${selected.length > 0 ? styles.SelectedBtnActive : ''}`}
                    onClick={() => { selected.length > 0 && setShowSelected(!showSelected) }}
                >{selected.length} 张已选择,查看已选图</p>
            }
        </div>
    )
})

export default PickFromProject